import { APICore } from "helpers/api/apiCore";
import config from "../../config";
import { FilterMetadata } from "redux/types";

const api = new APICore();

function fetchDashboardOperationsSummaryApi(params: FilterMetadata | Record<string, any> = {}) {
  const baseUrl = `${config.BACKEND_BASE_URL}/dashboard/dashboardOperationsSummary`;
  return api.get(`${baseUrl}`, params);
}

function fetchRenewalAndExpiryApi(params: FilterMetadata) {
  const baseUrl = `${config.BACKEND_BASE_URL}/dashboard/renewalAndExpiry`;
  return api.get(`${baseUrl}`, params);
}

function fetchTxnsByUserApi(params: FilterMetadata) {
  const baseUrl = `${config.BACKEND_BASE_URL}/dashboard/txnsByUser`;
  return api.get(`${baseUrl}`, params);
}

function fetchProgramPerformanceApi(params: FilterMetadata) {
  const baseUrl = `${config.BACKEND_BASE_URL}/dashboard/programPerformance`;
  return api.get(`${baseUrl}`, params);
}

function fetchProductMixApi(params: FilterMetadata) {
  const baseUrl = `${config.BACKEND_BASE_URL}/dashboard/productMix`;
  return api.get(`${baseUrl}`, params);
}

function fetchDashboardPortfolioAnalyticsSummaryApi(params: FilterMetadata | Record<string, any> = {}) {
  const baseUrl = `${config.BACKEND_BASE_URL}/dashboard/dashboardPortfolioAnalyticsSummary`;
  return api.get(`${baseUrl}`, params);
}

function fetchAgeingBucketsApi(params: FilterMetadata | Record<string, any> = {}) {
  const baseUrl = `${config.BACKEND_BASE_URL}/dashboard/ageingBuckets`;
  return api.get(`${baseUrl}`, params);
}

function fetchDisbursementByFYGraphApi(params: FilterMetadata | Record<string, any> = {}) {
  const baseUrl = `${config.BACKEND_BASE_URL}/dashboard/disbursementByFYGraph`;
  return api.get(`${baseUrl}`, params);
}

export {
  fetchDashboardOperationsSummaryApi,
  fetchRenewalAndExpiryApi,
  fetchTxnsByUserApi,
  fetchProgramPerformanceApi,
  fetchProductMixApi,
  fetchDashboardPortfolioAnalyticsSummaryApi,
  fetchAgeingBucketsApi,
  fetchDisbursementByFYGraphApi
};
